import type { PartialMessages } from './tr';
import { adminAr } from './admin.ar';
import { mobileAr } from './mobile.ar';

/** Arapça (F7-17): panel, vitrin ve mobil metinlerin tamamı; eksik anahtar raporu sıfır olmalı (`pnpm --filter @zt/i18n missing ar`). */
import { commonAr, errorsAr } from './shared.ar';
import { faz8PermissionsAr } from './faz8.ar';
import { storefrontAr } from './storefront.ar';
import { aiAr } from './ai.ar';

export const ar = {
  admin: adminAr,
  mobile: mobileAr,
  ai: aiAr.ui,
  common: commonAr,
  errors: errorsAr,
  roles: {
    owner: 'مالك النشاط',
    admin: 'مدير',
    store_manager: 'مدير المتجر',
    catalog_manager: 'مسؤول الكتالوج',
    pricing_manager: 'مسؤول الأسعار',
    operations: 'الطلبات / العمليات',
    warehouse: 'مسؤول المستودع',
    finance: 'المالية / المحاسبة',
    marketing: 'التسويق',
    content_editor: 'محرر المحتوى',
    vet_reviewer: 'المراجع البيطري المختص',
    customer_service: 'خدمة العملاء',
    dealer_rep: 'مندوب مبيعات الموزّعين',
    read_only: 'قراءة فقط / مدقق',
  },
  roleDescriptions: {
    owner: 'وصول كامل. يجب أن يحمل شخص واحد على الأقل هذا الدور.',
    admin: 'مثل المالك باستثناء منح دور المالك.',
    store_manager:
      'يدير العمليات اليومية: الكتالوج والطلبات والمخزون والعملاء والحملات. دون مفاتيح الدفع أو إدارة الأدوار.',
    catalog_manager: 'يدير المنتجات والفئات والصور وحقول SEO. يرى الأسعار لكن لا يمكنه تغييرها بشكل جماعي.',
    pricing_manager: 'يدير قوائم الأسعار والتسعير الجماعي وأسعار الحملات؛ ويرى التكاليف.',
    operations: 'يجهّز الطلبات ويشحنها ويعالج طلبات الإرجاع (دون الموافقة على استرداد المبالغ).',
    warehouse: 'حركات المخزون والجرد والنقل بين المستودعات؛ لا يرى الأسعار ولا بيانات اتصال العملاء.',
    finance: 'المدفوعات والاستردادات والتسويات والفواتير والتقارير المالية.',
    marketing: 'الحملات ورموز الخصم والبريد الإلكتروني/SMS وتقارير الإعلانات.',
    content_editor: 'يكتب مسودات الصفحات والمقالات؛ ولا يمكنه النشر.',
    vet_reviewer:
      'يوافق على محتوى الصحة/المكمّلات الغذائية والادعاءات الصحية للمنتجات. لا يمكن نشر المحتوى الصحي دون هذه الموافقة.',
    customer_service: 'يرى العملاء والطلبات، ويرد على تذاكر الدعم.',
    dealer_rep: 'يدير طلبات وعروض أسعار الموزّعين المعيَّنين له.',
    read_only: 'يرى كل شيء ولا يغيّر شيئًا؛ البيانات الشخصية مقنّعة.',
  },
  permissions: {
    ...aiAr.permissions,
    ...faz8PermissionsAr,
    'org.settings.read': 'عرض إعدادات النشاط التجاري',
    'org.settings.update': 'تغيير بيانات النشاط التجاري وإعداداته',
    'org.brand.read': 'عرض العلامات التجارية',
    'org.brand.manage': 'إنشاء العلامات التجارية وتعديلها',
    'org.store.read': 'عرض المتاجر',
    'org.store.manage': 'إدارة المتاجر والنطاقات والأسواق',
    'org.store.go_live': 'نشر المتاجر أو وضعها في الصيانة أو إيقاف نشرها (حساس)',
    'org.data.migrate': 'تصدير/استيراد حزمة الترحيل (لمالك النشاط فقط؛ حساس)',
    'org.user.read': 'عرض المستخدمين',
    'org.user.manage': 'دعوة المستخدمين وتغيير الأدوار والإيقاف المؤقت',
    'org.role.manage': 'إنشاء الأدوار المخصصة وتعديلها',
    'org.api_key.manage': 'إنشاء مفاتيح API وإلغاؤها',
    'org.webhook.manage': 'إدارة Webhooks',
    'org.integration.read': 'عرض حالة التكاملات',
    'org.integration.manage': 'إدخال بيانات اعتماد التكاملات واختبارها',
    'org.integration.go_live': 'تحويل التكاملات إلى البيئة المباشرة',
    'org.audit.read': 'عرض سجلات التدقيق',
    'org.system.read': 'عرض حالة النظام',
    'org.setup.manage': 'إدارة معالج الإعداد',
    'org.help.manage': 'تعديل نصوص المساعدة',
    'org.file.upload': 'رفع الملفات والصور',
    'org.job.read': 'عرض المهام في الخلفية',
    'catalog.product.read': 'عرض المنتجات',
    'catalog.product.write': 'إنشاء المنتجات وتعديلها',
    'catalog.product.publish': 'نشر المنتجات',
    'catalog.health_claim.approve': 'الموافقة على الادعاءات الصحية للمنتجات',
    'catalog.import': 'استيراد المنتجات',
    'catalog.bulk.apply': 'تطبيق العمليات الجماعية على المنتجات والتراجع عنها',
    'pricing.price.read': 'عرض الأسعار',
    'pricing.price.write': 'تعديل الأسعار',
    'pricing.bulk.apply': 'تطبيق تغييرات الأسعار الجماعية',
    'pricing.cost.read': 'عرض التكاليف وهوامش الربح',
    'inventory.stock.read': 'عرض المخزون',
    'inventory.stock.write': 'حركات المخزون والجرد',
    'customers.customer.read': 'عرض العملاء',
    'customers.customer.write': 'تعديل العملاء',
    'customers.pii.read': 'عرض البيانات الشخصية للعملاء دون إخفاء',
    'privacy.request.read': 'عرض طلبات أصحاب البيانات',
    'privacy.request.manage': 'تسجيل طلبات أصحاب البيانات والبت فيها',
    'privacy.retention.read': 'عرض مدد الاحتفاظ وسجل الإتلاف',
    'privacy.retention.manage': 'تفعيل قواعد الإتلاف التلقائي وتغييرها',
    'privacy.data.export': 'صاحب البيانات: تنزيل نسخة من البيانات الشخصية',
    'privacy.data.erase': 'صاحب البيانات: إخفاء هوية البيانات الشخصية (لا يمكن التراجع عنه)',
    'b2b.dealer.read': 'عرض الموزّعين',
    'b2b.dealer.manage': 'تعديل بيانات الموزّعين',
    'b2b.dealer.approve': 'الموافقة على طلبات الموزّعين أو رفضها',
    'b2b.ledger.read': 'عرض حسابات الموزّعين (الرصيد، كشف الحساب)',
    'b2b.ledger.manage': 'تسجيل مدفوعات الموزّعين والتسويات والأرصدة الافتتاحية؛ وتحديد شروط الدفع',
    'b2b.quote.read': 'عرض عروض أسعار الموزّعين',
    'b2b.quote.manage': 'إعداد عروض أسعار الموزّعين وإرسالها وإلغاؤها',
    'b2b.sales.manage': 'إدارة مناطق المبيعات؛ وتعيين الموزّعين للمندوبين والمناطق',
    'b2b.commission.read': 'عرض عمولات مندوبي المبيعات',
    'b2b.commission.manage': 'إدارة قواعد العمولة واحتساب الفترات والاعتماد ووضع علامة «مدفوع»',
    'orders.order.read': 'عرض الطلبات',
    'orders.order.write': 'تعديل الطلبات',
    'orders.refund.approve': 'الموافقة على استرداد المبالغ',
    'payments.payment.read': 'عرض المدفوعات',
    'payments.payment.capture': 'تسجيل استلام مدفوعات التحويل البنكي والدفع عند الاستلام والحساب الآجل',
    'payments.giftcard.read': 'عرض بطاقات الهدايا',
    'payments.giftcard.issue': 'إصدار بطاقات الهدايا وتعديل أرصدتها وتعطيلها (حساس)',
    'customers.credit.manage': 'إضافة رصيد المتجر للعملاء أو خصمه (حساس)',
    'payments.provider.manage':
      'إعدادات الدفع والحسابات البنكية ومفاتيح المزوّدين؛ وتحويل الدفع بالبطاقة إلى البيئة المباشرة',
    'shipping.shipment.write': 'عمليات الشحن',
    'shipping.method.manage': 'طرق الشحن وأسعاره',
    'invoices.invoice.read': 'عرض الفواتير',
    'invoices.invoice.write': 'إنشاء الفواتير وإرسالها',
    'legal.document.read': 'عرض النصوص القانونية',
    'legal.document.write': 'صياغة مسودات النصوص القانونية',
    'legal.document.publish': 'نشر النصوص القانونية',
    'content.read': 'عرض المحتوى',
    'content.write': 'كتابة المحتوى',
    'content.publish': 'نشر المحتوى',
    'content.expert_review': 'منح موافقة الخبير (البيطري)',
    'catalog.question.read': 'عرض أسئلة المنتجات',
    'catalog.question.answer': 'الإجابة عن أسئلة المنتجات ونشرها',
    'catalog.review.read': 'عرض تقييمات المنتجات',
    'catalog.review.moderate': 'الموافقة على تقييمات المنتجات ورفضها والرد عليها',
    'theme.read': 'عرض القالب',
    'theme.edit': 'تعديل القالب',
    'theme.publish': 'نشر القالب',
    'seo.read': 'عرض تقارير SEO',
    'seo.write': 'تعديل إعدادات SEO',
    'tracking.read': 'عرض إعدادات القياس وإحصاءات الموافقة على ملفات تعريف الارتباط',
    'tracking.manage': 'تعديل وسوم واجهة المتجر (GTM وGA4 وMeta وTikTok)',
    'marketing.campaign.read': 'عرض الحملات',
    'marketing.audience.read': 'عرض المشتركين وقائمة الحظر وسجلات İYS',
    'marketing.audience.manage': 'إدارة الاشتراكات وقائمة الحظر، ووضع علامات على سجلات İYS',
    'marketing.segment.manage': 'إنشاء شرائح العملاء وإعادة احتساب RFM',
    'marketing.campaign.write': 'إعداد الحملات',
    'marketing.campaign.send': 'إرسال الحملات',
    'reports.sales.read': 'تقارير المبيعات',
    'reports.finance.read': 'التقارير المالية',
    'automation.manage': 'إدارة الأتمتة',
    'marketing.loyalty.manage': 'إدارة برنامج الولاء',
    'marketing.referral.manage': 'إدارة برنامج الإحالة',
    'marketing.affiliate.manage': 'إدارة الشركاء التسويقيين والعمولات',
    'customers.ticket.read': 'عرض تذاكر الدعم',
    'customers.ticket.manage': 'الرد على تذاكر الدعم وإدارتها',
    'customers.chat.read': 'عرض قائمة انتظار الدردشة المباشرة',
    'customers.chat.manage': 'الرد في الدردشة المباشرة وإدارة إعدادات الدردشة',
    'marketing.ads.read': 'عرض مركز الإعلانات',
    'marketing.ads.manage': 'إدارة الحسابات الإعلانية ورفع البيانات وطلبات التغيير',
    'marketing.ads.approve': 'الموافقة على تغييرات ميزانية الإعلانات والنشر',
  },
  permissionModules: {
    ...aiAr.permissionModules,
    org: 'النشاط التجاري والإعدادات',
    catalog: 'الكتالوج',
    pricing: 'الأسعار',
    inventory: 'المخزون',
    customers: 'العملاء',
    b2b: 'الموزّعون',
    orders: 'الطلبات',
    payments: 'المدفوعات',
    shipping: 'الشحن',
    invoices: 'الفواتير',
    content: 'المحتوى',
    theme: 'القالب',
    seo: 'SEO',
    marketing: 'التسويق',
    reports: 'التقارير',
    automation: 'الأتمتة',
  },
  integrationStatus: {
    NOT_CONFIGURED: 'يتطلب الإعداد',
    SANDBOX: 'تجريبي (Sandbox)',
    LIVE: 'مباشر',
    ERROR: 'خطأ',
    DISABLED: 'معطّل',
  },
  integrationCategories: {
    email: 'البريد الإلكتروني',
    payment: 'المدفوعات',
    google: 'Google',
    ads: 'الإعلانات والقياس',
    messaging: 'المراسلة والموافقات',
    logistics: 'الشحن',
    invoicing: 'الفوترة الإلكترونية (e-Fatura / e-Arşiv)',
    infrastructure: 'البنية التحتية',
    ai: 'الذكاء الاصطناعي',
    mobile: 'الجوال',
    seo: 'بيانات SEO',
  },
  integrations: {
    smtp: {
      name: 'بريد SMTP',
      description: 'يرسل رسائل الطلبات وكلمات المرور والدعوات عبر خادم البريد الخاص بك.',
    },
    ses: {
      name: 'Amazon SES',
      description:
        'يرسل البريد عبر Amazon SES API؛ وتصل إشعارات الارتداد والشكاوى عبر SNS وتُضاف إلى قائمة الحظر.',
    },
    sendgrid: {
      name: 'SendGrid',
      description:
        'يرسل البريد عبر SendGrid API؛ مع webhook أحداث موقّع لحالات الارتداد والشكاوى وإلغاء الاشتراك.',
    },
    postmark: {
      name: 'Postmark',
      description:
        'تدفقات Postmark منفصلة لرسائل المعاملات ورسائل النشرة البريدية؛ مع webhooks للارتداد والشكاوى.',
    },
    iyzico: {
      name: 'iyzico',
      description: 'البطاقات و3D Secure والتقسيط واسترداد المبالغ.',
    },
    paytr: {
      name: 'PayTR',
      description: 'البطاقات والتقسيط وصفحة دفع للتحويل البنكي.',
    },
    param: {
      name: 'Param',
      description:
        'يتطلب الإعداد: صيغة المبلغ وحقول العودة وعنوان البيئة الحية لطريقة الدفع المستضافة لدى Param غير موجودة في الوثائق العامة؛ اطلب الوثائق من Param.',
    },
    sipay: {
      name: 'Sipay',
      description:
        'بطاقة ائتمان و3D Secure وتقسيط على صفحة دفع Sipay؛ استرداد جزئي. يتطلب التشغيل الحي إدراج عنوان IP ثابت لدى Sipay.',
    },
    paynet: {
      name: 'Paynet',
      description: 'اندمجت Paynet مع iyzico (علامة iyzico منذ 1 يناير 2026)؛ استخدم اتصال iyzico.',
    },
    stripe: {
      name: 'Stripe',
      description:
        'الدفع بالبطاقات بالعملات الأجنبية والمحافظ الرقمية (Apple Pay وGoogle Pay) عبر صفحة الدفع في Stripe. يُفتح الحساب باسم شركة في دولة تدعمها Stripe (تركيا غير مدعومة).',
    },
    paypal: {
      name: 'PayPal',
      description:
        'الدفع عبر PayPal (EUR وUSD وGBP). يعود الحساب إلى شركة خارج تركيا؛ إذ لا تعمل PayPal في تركيا.',
    },
    rank_tracking: {
      name: 'تتبع الترتيب',
      description:
        'يتطلب تتبع ترتيب الكلمات المفتاحية في Google يوميًا مزوّد بيانات مرخّصًا (مدفوعًا) (مثل DataForSEO وSemrush). يختار المالك المزوّد؛ وحتى ذلك الحين يُؤخذ الموضع من متوسط Search Console.',
    },
    pagespeed: {
      name: 'PageSpeed Insights',
      description:
        'سرعة الصفحة (Core Web Vitals): تُقاس الصفحة الرئيسية والفئة والمنتج ومقال المدونة أسبوعيًا. مفتاح Google Cloud API؛ مجاني.',
    },
    google_oauth: {
      name: 'حساب Google (عميل OAuth)',
      description:
        'عميل Google Cloud OAuth لخدمات Search Console وAnalytics وMerchant Center. يتم الربط من شاشة Google.',
    },
    google_merchant: {
      name: 'Google Merchant Center',
      description: 'موجز المنتجات والقوائم المجانية وShopping.',
    },
    google_search_console: {
      name: 'Google Search Console',
      description: 'أداء البحث وخرائط الموقع وتقارير الفهرسة.',
    },
    google_analytics: {
      name: 'Google Analytics 4',
      description: 'تحليلات الزيارات والمبيعات.',
    },
    google_tag_manager: {
      name: 'Google Tag Manager',
      description: 'إدارة العلامات.',
    },
    google_ads: {
      name: 'Google Ads',
      description: 'تقارير الإعلانات ورفع التحويلات.',
    },
    meta_ads: {
      name: 'الإنفاق الإعلاني على Meta',
      description: 'يقرأ يوميًا الإنفاق الإعلاني ومرات الظهور والنقرات على Facebook وInstagram (قراءة فقط).',
    },
    tiktok_ads: {
      name: 'الإنفاق الإعلاني على TikTok',
      description: 'يقرأ يوميًا الإنفاق الإعلاني ومرات الظهور والنقرات على TikTok (قراءة فقط).',
    },
    google_business_profile: {
      name: 'Google Business Profile',
      description: 'معلومات النشاط التجاري والتقييمات.',
    },
    meta: {
      name: 'Meta (Facebook/Instagram)',
      description: 'البكسل وConversions API.',
    },
    tiktok: {
      name: 'TikTok',
      description: 'البكسل وEvents API.',
    },
    iys: {
      name: 'İYS',
      description: 'السجل التركي لموافقات الرسائل التجارية (İYS).',
    },
    netgsm: {
      name: 'Netgsm (SMS)',
      description:
        'رسائل SMS للحملات وتقارير التسليم. يجب اعتماد اسم المرسل لدى Netgsm وتعيين رمز العلامة التجارية في İYS. يستعلم الاختبار عن الرصيد؛ ولا تُرسل أي رسالة SMS.',
    },
    iletimerkezi: {
      name: 'İleti Merkezi (SMS)',
      description:
        'رسائل SMS للحملات وتقارير التسليم. يجب أن يكون اسم المرسل معتمدًا. يستعلم الاختبار عن الرصيد؛ ولا تُرسل أي رسالة SMS.',
    },
    verimor: {
      name: 'Verimor (SMS)',
      description:
        'رسائل SMS للحملات وتقارير التسليم. يتطلب Verimor قائمة IP مسموحًا بها لواجهة API واسم مرسل معتمدًا. يستعلم الاختبار عن الرصيد؛ ولا تُرسل أي رسالة SMS.',
    },
    whatsapp: {
      name: 'WhatsApp Business (Cloud API)',
      description:
        'رسائل الحملات بقوالب معتمدة من Meta مع webhooks للتسليم. يقرأ الاختبار بيانات رقم الهاتف؛ ولا تُرسل أي رسالة.',
    },
    yurtici: {
      name: 'Yurtiçi Kargo',
      description: 'تسجيل الشحنات وتتبعها (خدمة الويب لشركة الشحن).',
    },
    aras: {
      name: 'Aras Kargo',
      description: 'تسجيل الشحنات وتتبعها (خدمة الويب لشركة الشحن).',
    },
    mng: {
      name: 'MNG Kargo (DHL eCommerce)',
      description: 'الشحنات وملصقات الباركود والتتبع (Apizone).',
    },
    geliver: {
      name: 'Geliver (شركات شحن متعددة)',
      description: 'شركات شحن عديدة عبر اتصال واحد: الأسعار والملصقات والتتبع.',
    },
    google_signin: {
      name: 'تسجيل الدخول عبر Google (العملاء)',
      description:
        '«المتابعة باستخدام Google» لعملاء المتجر: عميل OAuth مستقل؛ النطاقات openid والبريد والملف الشخصي فقط. يُفعَّل لكل متجر من المتاجر ← تسجيل دخول العملاء.',
    },
    bizimhesap: {
      name: 'BizimHesap',
      description: 'سجلات الفواتير من الطلبات؛ وتُصدر e-Arşiv/e-Fatura في BizimHesap.',
    },
    cloudflare: {
      name: 'Cloudflare',
      description:
        'شبكة توصيل المحتوى وجدار حماية التطبيقات وDNS. قرار استخدامه للمالك (اختياري)؛ يعمل الموقع بدون Cloudflare.',
    },
    s3_storage: {
      name: 'تخزين الكائنات (S3 / R2)',
      description:
        'Cloudflare R2 أو Backblaze B2 أو Hetzner أو أي تخزين آخر متوافق مع S3: حفظ الصور والمستندات خارج الخادم ونسخة مشفّرة خارجية من النسخ الاحتياطية الليلية.',
    },
    error_tracking: {
      name: 'تتبع الأخطاء',
      description: 'مراقبة أخطاء التطبيق.',
    },
    observability: {
      name: 'المراقبة (OpenTelemetry)',
      description:
        'تُرسَل مدد الطلبات ومهام الخلفية ومعدلات الأخطاء والتتبّعات عبر OTLP إلى مُجمِّع (Grafana Cloud أو Honeycomb أو New Relic أو OpenTelemetry Collector خاص بك). لا تُرسَل بيانات شخصية: فقط الطريقة وقالب المسار ورمز الحالة واسم المهمة.',
    },
    firebase: {
      name: 'Firebase (إشعارات Android)',
      description:
        'إشعارات مثل الطلبات الجديدة وطلبات الإرجاع في تطبيق الإدارة على Android (FCM). أدخل project_id وclient_email وprivate_key من مفتاح حساب الخدمة في Firebase.',
    },
    // Faz 9: ai_text, ai_image ve youtube metinleri ai.*.ts'de.
    ...aiAr.integrations,
  },
  integrationFields: {
    ...aiAr.integrationFields,
    iysCode: 'رقم İYS (رمز مزوّد الخدمة)',
    brandCode: 'رمز العلامة التجارية',
    autoSend: 'إرسال الموافقات والرفض إلى İYS تلقائيًا',
    endpoint: 'عنوان URL لنقطة النهاية (S3 API، https://…)',
    region: 'المنطقة (مثل eu-central-1 لـ Amazon؛ وauto لـ R2، والفارغ = auto)',
    bucket: 'اسم الحاوية (Bucket)',
    accessKeyId: 'معرّف مفتاح الوصول (Access Key ID)',
    secretAccessKey: 'مفتاح الوصول السري (Secret Access Key)',
    prefix: 'بادئة المجلد (اختياري، مثل zootopia/)',
    storeMedia: 'حفظ الصور والمستندات الجديدة في هذا التخزين',
    backupCopies: 'رفع نسخة مشفّرة خارجية من النسخ الاحتياطية إلى هنا',
    backupKeepDays: 'مدة الاحتفاظ بالنسخ الاحتياطية الخارجية (بالأيام؛ الفارغ = 30)',
    dsn: 'DSN (عنوان مشروع تتبع الأخطاء)',
    otlpEndpoint: 'عنوان المُجمِّع (OTLP/HTTP، https://…)',
    otlpHeaders: 'ترويسات المصادقة (الاسم=القيمة، مفصولة بفواصل؛ مثل Authorization=Basic …)',
    sampleRatio: 'نسبة أخذ عيّنات التتبّع (0–1؛ فارغ = 1، كل الطلبات)',
    host: 'مضيف الخادم',
    port: 'المنفذ',
    secure: 'SSL/TLS (فعّله للمنفذ 465)',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    fromEmail: 'بريد المرسل',
    fromName: 'اسم المرسل',
    apiKey: 'مفتاح API',
    secretKey: 'المفتاح السري',
    merchantId: 'معرّف التاجر',
    merchantKey: 'مفتاح التاجر',
    merchantSalt: 'ملح التاجر (Salt)',
    wsUserName: 'اسم مستخدم خدمة الويب',
    wsPassword: 'كلمة مرور خدمة الويب',
    codUserName: 'اسم مستخدم الدفع عند الاستلام (إن وجد)',
    codPassword: 'كلمة مرور الدفع عند الاستلام (إن وجدت)',
    setOrderUserName: 'اسم مستخدم إنشاء الشحنات',
    setOrderPassword: 'كلمة مرور إنشاء الشحنات',
    queryUserName: 'اسم مستخدم الاستعلام',
    queryPassword: 'كلمة مرور الاستعلام',
    customerCode: 'رمز العميل',
    clientId: 'معرّف العميل (Client ID)',
    clientSecret: 'سر العميل (Client Secret)',
    webhookSecret: 'مفتاح توقيع webhook (whsec_…)',
    appId: 'معرّف التطبيق (app_id)',
    saleWebhookKey: 'مفتاح إشعار المبيعات',
    webhookId: 'معرّف webhook',
    customerNumber: 'رقم العميل',
    apiToken: 'رمز API (Token)',
    firmId: 'معرّف الشركة (firmId)',
    token: 'رمز الوصول (يُستخدم معرّف الشركة إذا كان فارغًا)',
    configurationSetName: 'مجموعة الإعدادات (Configuration set، اختياري)',
    snsTopicArn: 'SNS Topic ARN (لإشعارات الارتداد/الشكاوى)',
    webhookPublicKey: 'المفتاح العام لـ Signed Event Webhook',
    euRegion: 'حساب منطقة الاتحاد الأوروبي (api.eu.sendgrid.com)',
    serverToken: 'رمز API للخادم (Server API token)',
    transactionalStream: 'تدفق المعاملات (الافتراضي outbound)',
    broadcastStream: 'معرّف تدفق النشرات (الافتراضي broadcast)',
    apiHash: 'سر API (hash)',
    header: 'اسم مرسل SMS (اسم مرسل معتمد، 11 حرفًا كحد أقصى)',
    accessToken: 'رمز الوصول (مستخدم النظام، دائم)',
    phoneNumberId: 'معرّف رقم الهاتف (Phone number ID)',
    wabaId: 'معرّف حساب WhatsApp Business (WABA ID)',
    appSecret: 'المفتاح السري للتطبيق (app_secret / App secret)',
    verifyToken: 'رمز التحقق من webhook (Verify token، تحدده أنت)',
    apiVersion: 'إصدار Graph API (اختياري، الافتراضي v23.0)',
    projectId: 'معرّف المشروع (project_id)',
    clientEmail: 'بريد حساب الخدمة (client_email)',
    privateKey: 'المفتاح الخاص (قيمة private_key كاملة من ملف JSON)',
    loginCustomerId: 'معرّف الحساب الإداري (MCC، اختياري، 123-456-7890)',
    adAccountId: 'معرّف الحساب الإعلاني (مع act_ أو أرقام فقط)',
    advertiserId: 'معرّف المعلن (Advertiser ID)',
  },
  integrationMessages: {
    ...aiAr.integrationMessages,
    health_timeout: 'لم يستجب المزوّد في الوقت المحدد.',
    health_unreachable: 'تعذّر الوصول إلى المزوّد.',
    health_skipped_messages:
      'يرسل هذا الاختبار رسالة أو حدثًا حقيقيًا إلى المزوّد، لذا لا يُشغَّل تلقائيًا. استخدم زر «اختبار الاتصال» الخاص بالاتصال.',
    health_skipped_remote_write:
      'يُنشئ هذا الاختبار سجلًا تجريبيًا لدى المزوّد ثم يحذفه، لذا لا يُشغَّل تلقائيًا. استخدم زر «اختبار الاتصال» الخاص بالاتصال.',
    health_skipped_paid_quota:
      'يستهلك هذا الاختبار حصة مدفوعة، لذا لا يُشغَّل تلقائيًا. استخدم زر «اختبار الاتصال» الخاص بالاتصال.',
    health_skipped_unknown: 'لا يوجد فحص تلقائي محدد لهذا الاتصال.',
    ses_ok: 'تم الاتصال بـ Amazon SES؛ والإرسال مفعّل.',
    ses_ok_sandbox:
      'تم الاتصال بـ Amazon SES، لكن الحساب في بيئة الاختبار (sandbox) ولا يرسل إلا إلى العناوين الموثّقة. اطلب الوصول إلى بيئة الإنتاج من AWS.',
    ses_invalid_settings: 'المنطقة (مثل eu-central-1) ومفاتيح الوصول وبريد المرسل مطلوبة.',
    ses_auth_failed: 'لم تُقبل مفاتيح وصول Amazon أو تفتقر إلى صلاحية SES.',
    ses_unreachable: 'تعذّر الوصول إلى Amazon SES.',
    ses_sending_disabled: 'الإرسال معطّل في حساب Amazon SES هذا (قد يكون موقوفًا مؤقتًا).',
    sendgrid_ok: 'تم الاتصال بـ SendGrid؛ ويمكن للمفتاح إرسال البريد.',
    sendgrid_invalid_settings: 'مفتاح API وبريد المرسل مطلوبان.',
    sendgrid_auth_failed: 'لم يُقبل مفتاح SendGrid API.',
    sendgrid_missing_scope: 'يفتقر مفتاح API إلى صلاحية "Mail Send".',
    sendgrid_unreachable: 'تعذّر الوصول إلى SendGrid.',
    postmark_ok: 'تم الاتصال بـ Postmark.',
    postmark_invalid_settings: 'رمز الخادم وبريد المرسل مطلوبان.',
    postmark_auth_failed: 'لم يُقبل رمز خادم Postmark.',
    postmark_unreachable: 'تعذّر الوصول إلى Postmark.',
    iys_ok: 'تم الاتصال بـ İYS (تم استلام الرمز)؛ ولم تُرسل أي موافقة.',
    iys_invalid_settings: 'رقم İYS ورمز العلامة التجارية (أرقام فقط) واسم المستخدم وكلمة المرور مطلوبة.',
    iys_auth_failed: 'لم يُقبل اسم مستخدم İYS أو كلمة المرور.',
    iys_rejected: 'رفض İYS السجل.',
    iys_unreachable: 'تعذّر الوصول إلى İYS.',
    s3_ok: 'تمت كتابة ملف اختبار وقراءته وحذفه؛ والاتصال يعمل.',
    s3_endpoint_invalid:
      'نقطة النهاية أو اسم الحاوية أو المفاتيح مفقودة أو غير صالحة (مطلوب عنوان S3 API يبدأ بـ https).',
    s3_auth_failed: 'رُفضت مفاتيح التخزين أو لا تملك صلاحية الكتابة في هذه الحاوية.',
    s3_bucket_missing: 'لا توجد حاوية بهذا الاسم؛ أنشئها في لوحة تحكم المزوّد.',
    s3_unreachable: 'تعذّر الوصول إلى خادم التخزين.',
    s3_verify_failed: 'تعذّرت قراءة ملف الاختبار دون تغيير.',
    error_tracking_ok:
      'أُرسل حدث اختبار إلى خدمة تتبع الأخطاء؛ يجب أن يظهر "Zootopia bağlantı testi" في لوحة تحكمها.',
    error_tracking_invalid_dsn: 'DSN غير صالح. الصق عنوان "Client Keys (DSN)" من إعدادات المشروع.',
    error_tracking_failed: 'لم تقبل خدمة تتبع الأخطاء حدث الاختبار؛ تحقّق من DSN والمشروع.',
    observability_ok: 'قبِل المُجمِّع حزمة تتبّع فارغة. ستظهر مدد الطلبات والمهام في المُجمِّع خلال دقائق.',
    observability_invalid:
      'عنوان المُجمِّع أو الترويسات غير صحيحة. يجب أن يبدأ العنوان بـ https (مثل https://otlp-gateway-….grafana.net/otlp)؛ والترويسات بصيغة "الاسم=القيمة" مفصولة بفواصل.',
    observability_failed:
      'لم يقبل المُجمِّع حزمة الاختبار؛ تحقّق من العنوان وترويسة المصادقة (مثل Authorization) في إعدادات OTLP لدى المُجمِّع.',
    pagespeed_ok: 'تم التحقق من مفتاح PageSpeed Insights؛ وقيست صفحة نموذجية.',
    pagespeed_key_format: 'تنسيق مفتاح API غير صحيح.',
    pagespeed_key_invalid: 'لم تقبل Google مفتاح API هذا.',
    pagespeed_quota: 'استُنفدت الحصة اليومية لـ PageSpeed Insights.',
    pagespeed_unreachable: 'تعذّر الوصول إلى PageSpeed Insights.',
    smtp_ok: 'تم الاتصال بخادم SMTP والمصادقة بنجاح.',
    google_client_ok: 'تم التحقق من معرّف عميل Google والسر. اربط حسابك الآن من شاشة Google.',
    google_client_invalid: 'لم تقبل Google معرّف العميل أو السر.',
    google_client_invalid_format:
      'يجب أن ينتهي معرّف العميل بـ ".apps.googleusercontent.com"؛ ولا يمكن أن يكون السر فارغًا.',
    google_signin_needs_domain:
      'يلزم الإعداد: يُجرى الاختبار بعنوان إعادة التوجيه الحقيقي للمتجر. أضف أولًا نطاقًا للواجهة من المتاجر.',
    google_invalid_request:
      'رفضت Google الطلب (invalid_request): {{description}} عنوان إعادة التوجيه المجرَّب: {{redirectUri}}. يجب أن يكون نطاقًا حقيقيًا بـ https ومدرجًا ضمن عناوين إعادة التوجيه المعتمدة للعميل في Google Cloud.',
    google_redirect_uri_mismatch:
      'عنوان إعادة التوجيه غير مسجّل في العميل على Google Cloud (redirect_uri_mismatch): {{redirectUri}}. أضفه من Google Auth Platform ← العملاء ← العميل ← عناوين إعادة التوجيه المعتمدة. {{description}}',
    google_client_rejected: 'رفضت Google الطلب ({{error}}): {{description}}',
    google_unreachable: 'تعذّر الوصول إلى Google. حاول مرة أخرى لاحقًا.',
    smtp_failed: 'فشل الاتصال بـ SMTP.',
    smtp_invalid_settings: 'المضيف أو المنفذ غير صالح.',
    smtp_private_host_blocked: 'عناوين الشبكة الداخلية محظورة لأسباب أمنية.',
    iyzico_ok: 'تم التحقق من اتصال iyzico.',
    iyzico_credentials_missing: 'مفتاح iyzico API والمفتاح السري غير مُدخلين.',
    iyzico_not_sandbox_key: 'تحتاج بيئة الاختبار إلى مفتاح اختبار من iyzico يبدأ بـ "sandbox-".',
    iyzico_sandbox_key_in_live: 'أُدخل مفتاح اختبار (sandbox) للبيئة المباشرة.',
    iyzico_auth_failed: 'رفضت iyzico المفاتيح.',
    iyzico_unreachable: 'تعذّر الوصول إلى iyzico. حاول مرة أخرى لاحقًا.',
    paytr_ok: 'تم التحقق من اتصال PayTR.',
    paytr_credentials_missing: 'معرّف التاجر ومفتاح التاجر والملح (Salt) في PayTR غير مُدخلة.',
    paytr_auth_failed: 'رفضت PayTR بيانات الاعتماد.',
    paytr_unreachable: 'تعذّر الوصول إلى PayTR. حاول مرة أخرى لاحقًا.',
    stripe_ok: 'تم التحقق من اتصال Stripe (تمت قراءة الرصيد).',
    stripe_credentials_missing: 'المفتاح السري لـ Stripe ومفتاح توقيع webhook غير مُدخلين.',
    stripe_key_invalid:
      'يجب أن يبدأ المفتاح السري بـ "sk_" (أو المقيّد "rk_")، وليس المفتاح القابل للنشر "pk_".',
    stripe_not_test_key: 'تحتاج بيئة الاختبار إلى مفتاح اختبار يبدأ بـ "sk_test_".',
    stripe_test_key_in_live: 'أُدخل مفتاح اختبار للبيئة المباشرة (مطلوب "sk_live_").',
    stripe_webhook_secret_invalid:
      'يجب أن يبدأ مفتاح توقيع webhook بـ "whsec_" (Stripe → Webhooks → نقطة النهاية).',
    stripe_mode_mismatch: 'وضع المفتاح (اختبار/مباشر) لا يطابق البيئة المحددة.',
    stripe_auth_failed: 'لم تقبل Stripe المفتاح.',
    stripe_unreachable: 'تعذّر الوصول إلى Stripe. حاول مرة أخرى لاحقًا.',
    sipay_ok: 'تم التحقق من اتصال Sipay (تم استلام رمز الوصول).',
    sipay_credentials_missing: 'لم يتم إدخال معرّف التطبيق والمفتاح السري للتطبيق ومفتاح التاجر في Sipay.',
    sipay_auth_failed: 'لم تُقبل بيانات اعتماد Sipay.',
    sipay_unreachable: 'تعذّر الوصول إلى Sipay. حاول مرة أخرى لاحقًا.',
    google_signin_client_ok: 'قبلت Google معرّف العميل والمفتاح السري.',
    geliver_ok:
      'تم التحقق من اتصال Geliver؛ عُثر على {{senders}} عنوان مرسل. البيئة الحية: تُخصم رسوم الملصق من رصيد Geliver.',
    geliver_ok_test:
      'تم التحقق من اتصال Geliver؛ عُثر على {{senders}} عنوان مرسل. بيئة الاختبار: تُنشأ الشحنات في Geliver كشحنات اختبار.',
    geliver_credentials_missing: 'لم يتم إدخال رمز API الخاص بـ Geliver.',
    geliver_auth_failed: 'رفضت Geliver رمز API. تحقّق من الرمز في لوحة Geliver (رموز API).',
    geliver_timeout: 'لم تستجب Geliver خلال 30 ثانية. حاول مرة أخرى لاحقًا.',
    geliver_unreachable: 'تعذّر الوصول إلى Geliver. حاول مرة أخرى لاحقًا.',
    geliver_unavailable:
      'لا تستطيع Geliver الاستجابة الآن (HTTP {{status}}). حاول بعد بضع دقائق؛ لن يُشترى الملصق مرتين.',
    geliver_rejected: 'رفضت Geliver الطلب: {{reason}}',
    geliver_unexpected_response: 'أعادت Geliver استجابة غير متوقعة؛ لم تكتمل العملية.',
    paypal_ok: 'تم التحقق من اتصال PayPal (تم العثور على webhook).',
    paypal_credentials_missing: 'معرّف عميل PayPal والسر ومعرّف webhook غير مُدخلة.',
    paypal_auth_failed: 'لم تقبل PayPal معرّف العميل أو السر.',
    paypal_webhook_not_found: 'لم يُعثر على معرّف webhook هذا في تطبيق PayPal الخاص بك.',
    paypal_unreachable: 'تعذّر الوصول إلى PayPal. حاول مرة أخرى لاحقًا.',
    bizimhesap_ok: 'تم التحقق من اتصال BizimHesap.',
    bizimhesap_credentials_missing: 'معرّف الشركة (firmId) في BizimHesap غير مُدخل.',
    bizimhesap_auth_failed: 'رفض BizimHesap بيانات الاعتماد. تحقّق من معرّف الشركة/المفتاح.',
    bizimhesap_unreachable: 'تعذّر الوصول إلى BizimHesap. حاول مرة أخرى لاحقًا.',
    bizimhesap_redirected:
      'أعاد BizimHesap توجيه الطلب (HTTP {{status}} → {{location}}). ربما تغيّر عنوان BizimHesap API؛ وتحتاج المنصة إلى تحديث.',
    bizimhesap_unexpected_response:
      'أعاد BizimHesap استجابة غير متوقعة (HTTP {{status}}، {{contentType}})؛ وهي ليست بتنسيق JSON. قد تكون الخدمة قيد الصيانة أو ربما تغيّر عنوان API.',
    bizimhesap_timeout: 'لم يستجب BizimHesap خلال 20 ثانية. حاول مرة أخرى لاحقًا.',
    netgsm_ok: 'تم التحقق من اتصال Netgsm (تمت قراءة الرصيد)؛ ولم تُرسل أي رسالة SMS.',
    netgsm_invalid_settings: 'بيانات الاعتماد واسم مرسل SMS لا يتجاوز 11 حرفًا مطلوبة.',
    netgsm_auth_failed: 'رفضت Netgsm بيانات الاعتماد.',
    netgsm_unreachable: 'تعذّر الوصول إلى Netgsm. حاول مرة أخرى لاحقًا.',
    netgsm_rejected: 'رفضت Netgsm الطلب؛ تحقّق من إعدادات الحساب.',
    iletimerkezi_ok: 'تم التحقق من اتصال İleti Merkezi (تمت قراءة الرصيد)؛ ولم تُرسل أي رسالة SMS.',
    iletimerkezi_invalid_settings: 'بيانات الاعتماد واسم مرسل SMS لا يتجاوز 11 حرفًا مطلوبة.',
    iletimerkezi_auth_failed: 'رفض İleti Merkezi بيانات الاعتماد.',
    iletimerkezi_unreachable: 'تعذّر الوصول إلى İleti Merkezi. حاول مرة أخرى لاحقًا.',
    iletimerkezi_rejected: 'رفض İleti Merkezi الطلب؛ تحقّق من إعدادات الحساب.',
    verimor_ok: 'تم التحقق من اتصال Verimor (تمت قراءة الرصيد)؛ ولم تُرسل أي رسالة SMS.',
    verimor_invalid_settings: 'بيانات الاعتماد واسم مرسل SMS لا يتجاوز 11 حرفًا مطلوبة.',
    verimor_auth_failed: 'رفضت Verimor بيانات الاعتماد.',
    verimor_unreachable: 'تعذّر الوصول إلى Verimor. تحقّق من قائمة IP المسموح بها.',
    verimor_rejected: 'رفضت Verimor الطلب؛ تحقّق من إعدادات الحساب.',
    whatsapp_ok: 'تم التحقق من اتصال WhatsApp Business (تمت قراءة بيانات الرقم)؛ ولم تُرسل أي رسالة.',
    whatsapp_invalid_settings: 'رمز الوصول ومعرّف رقم الهاتف وWABA ID وسر التطبيق ورمز التحقق مطلوبة.',
    whatsapp_auth_failed: 'رفضت Meta رمز الوصول أو أنه يفتقر إلى الصلاحية.',
    whatsapp_unreachable: 'تعذّر الوصول إلى Meta (WhatsApp).',
    whatsapp_rejected: 'رفضت Meta الطلب؛ تحقّق من معرّف رقم الهاتف.',
    firebase_ok: 'تم التحقق من حساب خدمة Firebase (تم استلام رمز الوصول)؛ ولم يُرسل أي إشعار.',
    firebase_invalid_settings:
      'معرّف المشروع وبريد حساب خدمة ينتهي بـ …iam.gserviceaccount.com والمفتاح الخاص (PEM) مطلوبة.',
    firebase_auth_failed: 'رفضت Google حساب الخدمة؛ تحقّق من أن المفتاح لم يُحذف وأن البريد صحيح.',
    firebase_unreachable: 'تعذّر الوصول إلى Google. حاول مرة أخرى لاحقًا.',
    google_ads_invalid_settings: 'يجب أن يتكون معرّف الحساب الإداري (MCC) من 10 أرقام (مثل 123-456-7890).',
    google_ads_settings_saved:
      'تم الحفظ. لم يعد رمز المطوّر مطلوبًا (Google، 9 سبتمبر 2026)؛ يعتمد الوصول على مستوى مشروع Google Cloud. معرّف الحساب الإداري (MCC) مطلوب فقط إذا كنت تصل إلى الحساب عبر حساب إداري.',
    google_ads_cloud_project_not_approved:
      'لا يستطيع مشروع Google Cloud الخاص بك الوصول عبر Google Ads API إلا إلى الحسابات التجريبية (وصول Test). للحساب الإعلاني الحقيقي، قدّم طلب الوصول Explorer في Google Cloud: Google Cloud Console ← Google Ads API ← نظرة عامة (مشروع عميل OAuth المستخدم في اتصال Google).',
    google_ads_user_permission_denied:
      'لا يستطيع حساب Google المرتبط الوصول إلى حساب Google Ads هذا. إذا كنت تصل إليه عبر حساب إداري (MCC)، فأدخل معرّف MCC في التكاملات ← Google Ads؛ وإذا أدخلته، فتحقق من أنه يدير هذا الحساب.',
    google_ads_customer_not_enabled: 'حساب Google Ads هذا غير مفعّل بعد أو تم إغلاقه.',
    google_ads_authorization_error:
      'رفض Google Ads التفويض. إذا رُفع مستوى وصول مشروع Cloud بعد 9 سبتمبر 2026، فقد تكون هذه مشكلة معروفة أبلغت عنها Google: أنشئ مشروع Google Cloud جديدًا وقدّم طلب الوصول Explorer.',
    google_ads_api_not_enabled:
      'واجهة Google Ads API غير مفعّلة في مشروع Google Cloud أو لم تُقبل شروط الخدمة. فعّل Google Ads API في Google Cloud Console.',
    google_scope_missing: 'لم تُمنح صلاحية Google لهذه الخدمة. أعد الاتصال مع تحديد الخدمة.',
    google_permission_denied:
      'لا يملك حساب Google المرتبط صلاحية الوصول إلى هذا المورد. تحقّق من مشاركة المورد (الموقع أو الخاصية أو الحساب) مع حساب Google هذا، أو أعد الربط بحساب يملك الوصول.',
    google_api_not_enabled:
      'واجهة API لهذه الخدمة غير مفعّلة في مشروع Google Cloud. فعّلها من Google Cloud Console ← واجهات API والخدمات ← المكتبة (مشروع عميل OAuth المستخدم في اتصال Google).',
    google_quota_exceeded: 'تم بلوغ حد طلبات Google. أعد المحاولة بعد قليل؛ تُعاد محاولة المزامنة تلقائيًا.',
    google_ads_quota_exceeded:
      'تم بلوغ حد طلبات Google Ads API. في وصول Explorer يوجد حد يومي للعمليات على الحسابات الحقيقية؛ تُعاد محاولة العملية تلقائيًا لاحقًا.',
    google_ads_access_prohibited:
      'الوصول إلى Google Ads API محظور لمشروع Google Cloud هذا. تحقّق من مستوى وصول Google Ads API في Google Cloud Console.',
    google_ads_action_not_permitted:
      'لا يُسمح لحساب Google المرتبط بتنفيذ هذه العملية في حساب Google Ads هذا (قد يكون وصوله للقراءة فقط). اربط حسابًا بوصول قياسي أو إداري.',
    google_ads_account_suspended:
      'حساب Google Ads معلّق؛ لا يمكن إجراء تغييرات. تحقّق من حالة الحساب في Google Ads.',
    google_ads_not_allowlisted: 'ميزة Google Ads هذه غير متاحة لحسابك (تتطلب إدراجًا من Google).',
    google_ads_policy_violation:
      'رُفض بموجب سياسة إعلانات Google. عدّل النص أو المنتج؛ لا تُستخدم في المنتجات الصحية عبارات مثل «يعالج» أو «يقي» أو «يشفي». التفاصيل في حالة السياسة للحملة.',
    google_ads_budget_too_low: 'الميزانية اليومية منخفضة جدًا لـ Google Ads. أدخل ميزانية يومية أعلى.',
    google_ads_budget_too_high: 'الميزانية اليومية تتجاوز الحد الأقصى في Google Ads.',
    google_ads_budget_currency: 'مبلغ الميزانية لا يطابق عملة الحساب أو أصغر وحدة فيها.',
    google_ads_budget_invalid:
      'رفض Google Ads إعداد الميزانية. تحقّق من أن الميزانية غير مستخدمة في حملة أخرى ولم تُحذف.',
    google_ads_duplicate_name: 'توجد حملة أو ميزانية بهذا الاسم. أدخل اسمًا مختلفًا.',
    google_ads_bid_out_of_range: 'قيمة العرض خارج حدود Google Ads.',
    google_ads_bidding_invalid:
      'لا يمكن استخدام استراتيجية عروض الأسعار المختارة مع نوع الحملة أو الميزانية.',
    google_ads_temporary_error: 'أعاد Google Ads خطأً مؤقتًا. تُعاد محاولة العملية تلقائيًا بعد قليل.',
    google_ads_resource_not_found:
      'لم يُعثر على المورد في Google Ads (ربما حُذف من Google Ads). زامن ثم أعد المحاولة.',
    google_ads_value_out_of_range: 'القيمة خارج حدود Google Ads.',
    google_ads_resource_limit: 'بلغ حساب Google Ads حدًّا للموارد (مثل عدد الحملات أو الأصول).',
    google_ads_request_rejected: 'رفض Google Ads الطلب. راجع سجل اتصال Google للتفاصيل.',
    ads_ok: 'تمت قراءة الحساب الإعلاني: {{account}} ({{currency}}). تُزامَن بيانات الإنفاق كل صباح.',
    ads_credentials_format: 'رمز الوصول ومعرّف الحساب مطلوبان؛ ويجب أن يتكوّن معرّف الحساب من أرقام فقط.',
    ads_token_invalid: 'رمز الوصول غير صالح أو منتهي الصلاحية. أنشئ رمزًا جديدًا واحفظه.',
    ads_permission: 'لا يمكن للرمز قراءة هذا الحساب الإعلاني (صلاحية ads_read / التقارير).',
    ads_rate_limited: 'تم بلوغ حد الطلبات في المنصة؛ ستُعاد محاولة المزامنة لاحقًا.',
    ads_account_not_found: 'لم يُعثر على الحساب الإعلاني؛ تحقّق من المعرّف.',
    ads_unreachable: 'تعذّر الوصول إلى المنصة الإعلانية. حاول مرة أخرى لاحقًا.',
    ads_timeout: 'لم تستجب المنصة الإعلانية في الوقت المحدد. حاول مرة أخرى لاحقًا.',
    ads_bad_response: 'استجابة غير متوقعة من المنصة الإعلانية.',
    ads_provider_error: 'رفضت المنصة الإعلانية الطلب. راجع سجل أخطاء المنصة لمزيد من التفاصيل.',
  },
  setupSteps: {
    business: 'بيانات النشاط التجاري',
    brand: 'إضافة علامة تجارية',
    logo: 'رفع الشعار',
    colors: 'اختيار الألوان',
    domain: 'ربط النطاق',
    currency: 'العملة والسوق',
    tax: 'إعداد الضرائب',
    import_products: 'استيراد المنتجات',
    warehouse: 'إنشاء مستودع',
    shipping: 'ربط الشحن',
    pos_application: 'تجهيز طلب نقطة البيع (POS)',
    pos_connect: 'ربط نقطة البيع (POS)',
    email_service: 'ربط خدمة البريد الإلكتروني',
    search_console: 'ربط Search Console',
    ga4: 'ربط GA4',
    gtm: 'ربط GTM',
    merchant_center: 'ربط Merchant Center',
    seo: 'إكمال إعدادات SEO',
    legal_pages: 'مراجعة الصفحات القانونية',
    test_order: 'إنشاء طلب تجريبي',
    payment_tests: 'تشغيل اختبارات الدفع',
    security_checks: 'إكمال فحوصات الأمان',
    preview_store: 'معاينة المتجر',
    go_live: 'الإطلاق المباشر بموافقة المسؤول',
  },
  setupStatus: {
    done: 'مكتمل',
    pending: 'قيد الانتظار',
    skipped: 'تم التخطي',
    locked: 'مقفل',
  },
  storefront: storefrontAr,
  auditActions: {
    ...aiAr.auditActions,
    'company.member.add': 'تمت إضافة مستخدم للشركة',
    'company.member.update': 'تغيّر دور مستخدم الشركة أو حده',
    'company.member.remove': 'تمت إزالة مستخدم من الشركة',
    'customer.access_link.activation': 'تم إنشاء رابط التفعيل',
    'api_key.create': 'تم إنشاء مفتاح API',
    'api_key.revoke': 'تم إلغاء مفتاح API',
    'brand.create': 'تمت إضافة علامة تجارية',
    'brand.update': 'تم تحديث العلامة التجارية',
    'domain.create': 'تمت إضافة نطاق',
    'domain.delete': 'تمت إزالة النطاق',
    'help.update': 'تم تحديث نص المساعدة',
    'integration.credentials_saved': 'تم حفظ بيانات اعتماد التكامل',
    'integration.disconnected': 'تم قطع اتصال التكامل',
    'integration.tested': 'تم اختبار التكامل',
    'market.create': 'تمت إضافة سوق',
    'market.delete': 'تمت إزالة السوق',
    'member.invitation_accepted': 'تم قبول الدعوة',
    'member.invitation_revoke': 'تم سحب الدعوة',
    'member.invite': 'تمت دعوة مستخدم',
    'member.remove': 'تمت إزالة المستخدم',
    'member.update': 'تم تغيير دور المستخدم',
    'organization.update': 'تم تحديث بيانات النشاط التجاري',
    'role.create': 'تم إنشاء دور مخصص',
    'role.delete': 'تم حذف الدور المخصص',
    'role.update': 'تم تحديث الدور المخصص',
    'settings.update': 'تم تحديث الإعدادات',
    'setup.step_marked': 'تم تعليم خطوة الإعداد',
    'store.create': 'تم إنشاء المتجر',
    'store.update': 'تم تحديث المتجر',
    'webhook.create': 'تمت إضافة Webhook',
    'webhook.delete': 'تم حذف Webhook',
    'webhook.redeliver': 'تمت إعادة إرسال Webhook',
    'webhook.rotate_secret': 'تم تجديد سر توقيع Webhook',
    'webhook.update': 'تم تحديث Webhook',
  },
  auditEntities: {
    company: 'شركة الموزّع',
    customer: 'العميل',
    api_key: 'مفتاح API',
    brand: 'العلامة التجارية',
    custom_role: 'دور مخصص',
    domain: 'النطاق',
    help_entry: 'نص المساعدة',
    integration: 'التكامل',
    invitation: 'الدعوة',
    market: 'السوق',
    membership: 'المستخدم',
    organization: 'النشاط التجاري',
    settings: 'الإعدادات',
    setup_step: 'خطوة الإعداد',
    store: 'المتجر',
    webhook_delivery: 'تسليم Webhook',
    webhook_endpoint: 'Webhook',
  },
  healthClaims: {
    treatment: 'ادعاء علاجي',
    cure: 'ادعاء الشفاء',
    prevention: 'ادعاء الوقاية',
    disease: 'اسم مرض',
    drug: 'صياغة دوائية',
    guarantee: 'وعد بنتيجة مضمونة',
  },
  publishBlockers: {
    product_not_active: 'المنتج غير نشط.',
    vet_approval_required: 'يتطلب المحتوى الصحي موافقة بيطرية.',
    base_price_required: 'لا يوجد سعر في قائمة الأسعار الأساسية للمتجر.',
  },
  events: {
    'organization.updated': 'تغيّرت بيانات النشاط التجاري',
    'brand.created': 'تم إنشاء علامة تجارية',
    'brand.updated': 'تم تحديث العلامة التجارية',
    'store.created': 'تم إنشاء متجر',
    'store.updated': 'تم تحديث المتجر',
    'member.invited': 'تمت دعوة مستخدم',
    'member.updated': 'تغيّر دور المستخدم/حالته',
    'integration.error': 'خطأ في التكامل',
    'integration.connected': 'تم ربط التكامل',
    'webhook.test': 'حدث تجريبي',
    'product.created': 'تم إنشاء منتج',
    'product.updated': 'تم تحديث المنتج',
    'product.published': 'تم نشر المنتج',
    'product.unpublished': 'تم إلغاء نشر المنتج',
    'price.changed': 'تغيّر السعر',
    'stock.changed': 'تغيّر المخزون',
    'customer.created': 'تم إنشاء عميل',
    'dealer.applied': 'تم استلام طلب انضمام موزّع',
    'dealer.approved': 'تمت الموافقة على الموزّع',
    'order.created': 'تم إنشاء طلب',
    'order.status_changed': 'تغيّرت حالة الطلب',
    'order.updated': 'تم تعديل الطلب',
    'order.items_cancelled': 'تم إلغاء منتجات في طلب (إلغاء جزئي)',
    'payment.captured': 'تم تحصيل الدفعة',
    'payment.failed': 'فشل الدفع',
    'payment.review_required': 'الدفعة بحاجة إلى مراجعة (يلزم قرار يدوي)',
    'store.went_live': 'تم إطلاق المتجر',
    'return.requested': 'تم فتح طلب إرجاع/انسحاب',
    'privacy.requested': 'تم استلام طلب من صاحب البيانات (KVKK)',
    'privacy.anonymized': 'طلب حذف: تم إخفاء هوية البيانات الشخصية',
    'form.submitted': 'تم استلام رسالة من نموذج الاتصال',
    'dealer.balance_paid': 'دفع الموزّع رصيد حسابه بالبطاقة',
    'return.completed': 'اكتمل طلب الإرجاع',
    'theme.published': 'تم نشر القالب',
    'page.published': 'تم نشر الصفحة',
    'post.published': 'تم نشر مقالة المدونة',
    'refund.created': 'تم استرداد المبلغ',
    'shipment.created': 'تم إنشاء شحنة',
    'shipment.updated': 'تغيّرت حالة الشحنة',
    'invoice.sent': 'تم إرسال الفاتورة',
    'legal.published': 'تم نشر نص قانوني',
  },
} satisfies PartialMessages;
